export const permissionData = {
  "shipper-individual": {
    menu: [
      "dashboard",
      "Myloadboard",
      "tripevents",
      "completeorder",
      "invoice",
      "payments",
      "partnerrequests",
      "myteam",
      "supportcenter",
      "usersubsriptnwarehouse",
      "mysubscriptionswarehouse",
    ],
  },

  "shipper-enterprise": {
    menu: [
      "dashboard",
      "Myloadboard",
      "tripevents",
      "completeorder",
      "invoice",
      "payments",
      "partnerrequests",
      "myteam",
      "mysubscription",
      "mywarehousesubscription",
      "supportcenter",
      "usersubsriptnwarehouse",
      "mysubscriptionswarehouse",
      "mysubscriptions",
      "availableplans"
    ],
  },

  shprAccount: {
    menu: [
      "dashboard",
      "invoice",
      "payments",
      "partnerrequests",
      // "mysubscription",
      // "mywarehousesubscription",
      // "usersubsriptnwarehouse",
      // "mysubscriptionswarehouse",
    ],
  },

  shprSupport: {
    menu: [
      "dashboard",
      // "Myloadboard",
      // "tripevents",
      "completeorder",
      "invoice",
      "payments",
      "partnerrequests",
      // "myteam",
      // "mysubscription",
      // "mywarehousesubscription",
      "supportcenter",
      // "usersubsriptnwarehouse",
      // "mysubscriptionswarehouse",
    ],
  },

  runner: {
    menu: [
      "dashboard",
      "tripdesign",
      "tripevents",
      "completeorder",
      "runnerinvoice",
      // "payments",
      "runnerpayments",
      "partnerrequests",
      "expense",
      "shippers",
      "drivers",
      "myvehicles",
      "myteam",
      "ratecard",
      "supportcenter",
      "myplan",
      "operatingLocation",
      "subscriptions",
      "mywarehousesubscription",
      "usersubsriptnwarehouse",
      "mysubscriptionswarehouse",
      "branding",
      "brandingInvoice"
      // "loadMetrics"
    ],
  },

  runnerSupport: {
    menu: [
      "dashboard",
      "tripdesign",
      "tripevents",
      "completeorder",
      "runnerinvoice",
      // "payments",
      "runnerpayments",
      "partnerrequests",
      "expense",
      "shippers",
      "drivers",
      "myvehicles",
      "myteam",
      "ratecard",
      "supportcenter",
      "myplan",
      "operatingLocation",
      "subscriptions",
      "mywarehousesubscription",
      "usersubsriptnwarehouse",
      "mysubscriptionswarehouse",
      "branding",
      "brandingInvoice"
      // "loadMetrics"
    ],
  },

  runnerAccount: {
    menu: [
      "dashboard",

      "runnerinvoice",
      // "payments",
      "runnerpayments",
      "partnerrequests",
      "expense",
      "ratecard",
      "supportcenter",
      "myplan",
      "subscriptions",
      "mywarehousesubscription",
      "usersubsriptnwarehouse",
      "mysubscriptionswarehouse",
      "branding",
      "brandingInvoice"
    ],
  },

  runnerTrip: {
    menu: [
      "dashboard",
      "tripdesign",
      "tripevents",
      "completeorder",
      "expense",
      "drivers",
      "myvehicles",
      "supportcenter",
      "operatingLocation",
      "usersubsriptnwarehouse",
      "mysubscriptionswarehouse",
      "branding",
      "brandingInvoice"
    ],
  },
  warehouse: {
    menu: [
      "dashboard",
      "warehouse",
      "warehousemanagement",
      "warehouseplan",
      "warehousesubscriptions",
      "invoice",
      "payments",
      "partnerrequests",
      "supportcenter",
      "warehouseperformance",
      "branding",
      "brandingInvoice"
    ],
  },
};
